export function formatNumber(
  number: any,
  showDecimal: boolean,
  divideNumber: number
): string {
  if (isNaN(parseFloat(number))) {
    number = 0;
  }

  number = parseFloat(number) / divideNumber; // 将分转换为元

  if (showDecimal) {
    return toFixedNumber(number, 2).toString();
    // return number.toFixed(2);
  } else {
    return Math.round(number).toString();
  }
}

// 保留小数位
export function toFixedNumber(num, precision) {
  const factor = Math.pow(10, precision);
  return Math.round(num * factor) / factor;
}

// 计算百分比
export function calcPercent(
  numerator: number,
  denominator: number,
  showDecimal: boolean
): number {
  if (isNaN(numerator) || isNaN(denominator)) {
    return 0;
  }

  const percent = (numerator / denominator) * 100;
  let progress = Math.floor(percent);
  if (showDecimal) {
    progress = parseFloat(percent.toFixed(2));
  }
  return progress > 100 ? 100 : progress;
}

export function calcMinute(dateStr: string) {
  // 创建一个表示当前时间的Date对象
  const now = new Date();

  // 创建一个表示"2023/10/25 14:00:00"的Date对象
  const targetDate = new Date(dateStr);

  // 计算两个时间的差值（毫秒）
  const diff = targetDate.getTime() - now.getTime();

  // 将差值转换为分钟
  const diffInMinutes = Math.round(diff / 1000 / 60);
  return diffInMinutes;
}

export function regexMobile(mobile: string) {
  return /^1[1-9]\d{9}$/.test(mobile);
}

export function regexLengthNumber(number: string, length: number) {
  return new RegExp(`^\\d{${length}}$`).test(number);
}

export function keywordHighlight(text: string, keywords: string[]) {
  const highlights = keywords;
  if (!text || !highlights || !Array.isArray(highlights)) return text;

  // Escape special characters for regex
  const escapeRegExp = (str: string) =>
    str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

  // Create a regular expression to match all highlight terms
  const regex = new RegExp(`(${highlights.map(escapeRegExp).join('|')})`, 'gi');
  // console.warn(regex);

  // Replace matched terms with highlighted versions
  return text.replace(
    regex,
    '<span class="highlight" style="color: #f50;font-weight: bold;">$1</span>'
  );
}
/**
 * 检查数字格式
 * @param {*} value - 要检查的值
 * @param {Object} options - 配置选项
 * @param {boolean} options.allowDecimal - 是否允许小数，默认true
 * @param {number} options.maxDecimalPlaces - 最大小数位数，默认2
 * @returns {Object} 检查结果
 */
export function validateNumber(
  value,
  options = {
    allowDecimal: true,
    maxDecimalPlaces: 2,
  }
) {
  const { allowDecimal = true, maxDecimalPlaces = 2 } = options;

  // 基本类型检查
  if (value === null || value === undefined || value === '') {
    return {
      isValid: false,
      message: '值不能为空',
    };
  }

  // 转换为数字
  const num = Number(value);

  // 检查是否为有效数字
  if (isNaN(num)) {
    return {
      isValid: false,
      message: '不是有效的数字',
    };
  }

  // 检查是否为正数
  if (num <= 0) {
    return {
      isValid: false,
      message: '必须为大于0的正数',
    };
  }

  // 检查是否为整数（如果不允许小数）
  if (!allowDecimal) {
    if (!Number.isInteger(num)) {
      return {
        isValid: false,
        message: '必须为整数，不能有小数',
      };
    }
  }

  // 检查小数位数
  if (allowDecimal) {
    const decimalPart = value.toString().split('.')[1];
    if (decimalPart && decimalPart.length > maxDecimalPlaces) {
      return {
        isValid: false,
        message: `小数位数不能超过${maxDecimalPlaces}位`,
      };
    }
  }

  return {
    isValid: true,
    value: num,
    message: '验证通过',
  };
}

// 解析：如果是数组就以指定的分割，否则输出文本
export function getTextByArrayOrText(value, separator = ',') {
  if (typeof value === 'string') {
    return value;
  }
  if (typeof value === 'object' && Array.isArray(value)) {
    return value.join(separator);
  }
  return value;
}
export function replaceMarkedText(markedItems, originalText) {
  if (!Array.isArray(markedItems) || typeof originalText !== 'string') {
    return originalText || '';
  }

  let result = originalText;
  const processedItems = new Set();

  for (const markedItem of markedItems) {
    if (typeof markedItem !== 'string' || processedItems.has(markedItem)) {
      continue;
    }
    processedItems.add(markedItem);

    // 提取这个元素中的所有<mark>标签内的纯文本，并合并成连续的字符串
    const matches = markedItem.match(/<mark>(.*?)<\/mark>/g);
    if (!matches || matches.length === 0) continue;

    // 将所有<mark>标签内的文本连接起来
    const combinedText = matches
      .map((tag) => tag.replace(/<\/?mark>/g, ''))
      .join('');

    // 在原始文本中查找这个连续的文本
    if (originalText.includes(combinedText)) {
      // 用带<mark>标签的版本替换
      result = result.replace(combinedText, () => markedItem);
    }
  }

  return result;
}
export function replaceMarkedTextV2(markedItems, originalText) {
  if (!Array.isArray(markedItems) || typeof originalText !== 'string') {
    return originalText || '';
  }

  // 存储已处理的片段，避免重复替换
  const processedSegments = new Set();
  let result = originalText;

  for (const markedItem of markedItems) {
    if (typeof markedItem !== 'string' || !markedItem.includes('<mark>')) {
      continue;
    }

    // 提取<mark>标签内的纯文本
    const markedMatch = markedItem.match(/<mark>(.*?)<\/mark>/g);
    if (!markedMatch) continue;

    for (const tag of markedMatch) {
      const textContent = tag.replace(/<\/?mark>/g, '');

      // 避免重复处理相同的片段
      if (processedSegments.has(textContent)) {
        continue;
      }

      processedSegments.add(textContent);

      // 在原始文本中查找对应的文本片段
      // 注意：这里使用正则表达式的字面量匹配，处理特殊字符
      const escapedText = textContent.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      const regex = new RegExp(escapedText, 'g');

      if (regex.test(originalText)) {
        // 如果原始文本中包含这个文本片段，用带mark标签的版本替换
        result = result.replace(regex, () => `<mark>${textContent}</mark>`);
      }
    }
  }

  return result;
}

// 跳转到外部链接
export function openExternalLink(url) {
  // 如果没有http或https协议，则默认加上http
  if (!/^https?:\/\//i.test(url)) {
    url = 'http://' + url;
  }
  window.open(url, '_blank');
}
